const o = (a) => ({ sizes: {
  xsmall: {
    height: a * 1.625,
    paddingHorizontal: a * 0.5,
    textVariant: "body3"
  },
  small: {
    height: a * 2,
    paddingHorizontal: a * 0.5,
    textVariant: "body2"
  },
  regular: {
    height: a * 2.5,
    paddingHorizontal: a,
    textVariant: "body1"
  },
  medium: {
    height: a * 3,
    paddingHorizontal: a,
    textVariant: "body1"
  }
}, variants: {
  primary: {
    backgroundColorName: {
      inactive: "WHITE",
      active: "BLACK",
      hover: "WHITE",
      disabled: "GREY_1"
    },
    colorName: {
      inactive: "BLACK",
      active: "WHITE",
      hover: "BLACK",
      disabled: "BLACK_50"
    },
    borderColorName: {
      inactive: "GREY_3",
      active: "BLACK",
      hover: "BLACK",
      disabled: "GREY_1"
    },
    fontWeight: {
      inactive: 400,
      active: 500,
      hover: 500,
      disabled: 400
    }
  }
} });
export {
  o as default
};
//# sourceMappingURL=tab.js.map
